import { v4 } from 'uuid';
import { DEFAULT_NODE_COLOR, defaultSizeOf } from '../Shapes/shapeCatalog';

// Gap (flow px) between a node and one inserted next to it.
const INSERT_GAP = 60;
const HALF = 0.5;

export const newNodeId = () => `node-${v4()}`;
export const newEdgeId = () => `edge-${v4()}`;

// A new node in the shape the app creates everywhere else (sidebar drop, "+").
export const createNode = ({ type, position, userInfo, userColor }) => {
    const id = newNodeId();
    return {
        creatorId: userInfo.userId,
        id,
        position,
        data: { id, label: '', nodeBg: DEFAULT_NODE_COLOR, textBg: '#000', allocatedColor: userColor },
        type,
    };
};

// The node's size on the canvas: measured, else saved style, else its type's default.
export const sizeOfNode = (node) => {
    if (node.width && node.height) return { width: node.width, height: node.height };
    if (node.style?.width && node.style?.height) return { width: node.style.width, height: node.style.height };
    return defaultSizeOf(node.type) ?? { width: 0, height: 0 };
};

// Handles of the edge that connects a node to one inserted on that side of it.
const SIDES = {
    above: { sourceHandle: 'top', targetHandle: 'bottom' },
    below: { sourceHandle: 'bottom', targetHandle: 'top' },
    left: { sourceHandle: 'left', targetHandle: 'right' },
    right: { sourceHandle: 'right', targetHandle: 'left' },
};

export const INSERT_SIDES = Object.keys(SIDES);

// Where a node of the same type goes when inserted on `side` of `node`: a gap away, centred on that side.
export const insertPosition = (node, side) => {
    const { width, height } = sizeOfNode(node);
    const size = defaultSizeOf(node.type) ?? { width, height };
    const { x, y } = node.position;
    const centredX = x + (width - size.width) * HALF;
    const centredY = y + (height - size.height) * HALF;
    if (side === 'above') return { x: centredX, y: y - size.height - INSERT_GAP };
    if (side === 'below') return { x: centredX, y: y + height + INSERT_GAP };
    if (side === 'left') return { x: x - size.width - INSERT_GAP, y: centredY };
    return { x: x + width + INSERT_GAP, y: centredY };
};

export const connectingEdge = (source, target, side, documentId) => ({
    id: newEdgeId(),
    documentId,
    source: source.id,
    target: target.id,
    ...SIDES[side],
});
